export enum AppRoutes {
    Admin = "admin",
    AtsChecker = "ats-checker",
    Ai = "ai",
    Stats = "stats",
    Assistant = "assistant",
    AssistantItem = "assistant/:assistantItemId",
    CreditActions = "credit-actions",
    CreditAction = "credit-actions/:creditActionId",
    Dashboard = "/",
    DocumentType = "document-types/:documentTypeId",
    DocumentTypes = "document-types",
    Examples = "examples",
    ForgotPassword = "forgot-password",
    LivePreview = "live-preview",
    Login = "login",
    Logout = "logout",
    Portal = "portal",
    PortalDashboard = "dashboard",
    PortalUsers = "users-new",
    PortalUserDetails = "users-new/:userId",
    Preferences = "preferences",
    Preview = "preview/:id",
    Profile = "profile",
    ResetPassword = "reset-password",
    Resume = "resume/:id",
    Section = "sections/:sectionId",
    Sections = "sections",
    Signup = "signup",
    Styles = "styles",
    Template = "templates/:templateId",
    Templates = "templates",
    User = "users/:userId",
    Users = "users",
    Verify = "verify",
    YourJobs = "your-jobs",
    Jobs = "jobs",
    TenantMe = "tenant/me",
    Tenants = "tenants",
    TenantForm = "tenants/:tenantId",
}

export enum SiteRoutes {
    Landing = "https://1template.io",
    PrivacyPolicy = "https://1template.io/privacy-policy",
    Terms = "https://1template.io/terms-of-service",
    CookiePolicy = "https://1template.io/privacy-policy#using-our-platform-and-cookies",
    About = "https://1template.io/about",
    Blog = "https://1template.io/blog",
    Pricing = "https://1template.io/pricing",
}

export enum SocialMediaRoutes {
    Instagram = "https://www.instagram.com/1template.io/",
    LinkedIn = "https://www.linkedin.com/company/1template/about",
}
